import { render } from "./ClientCardPage.vue?vue&type=template&id=c12cc16c&scoped=true"
import script from "./ClientCardPage.vue?vue&type=script&lang=ts"
export * from "./ClientCardPage.vue?vue&type=script&lang=ts"

import "./ClientCardPage.vue?vue&type=style&index=0&id=c12cc16c&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-c12cc16c"

export default script